import { IMatrixServer } from "@API/Matrix/types";
import { RootState } from "@Store";

export const selectMatrixServers = (state: RootState): IMatrixServer[] =>
  state.matrix.general.list;
